'use strict';

angular.module('ClinicApp').factory('ReviewService', function($http, $q, ClinicConfig) {
  return {
    createPatientReview: function(patientId, clinicId, data) {
      data = data || {};
      data.clinicId = clinicId;

      return $http.post(ClinicConfig.HOSTNAME + '/patient/' + patientId + '/review', data, {
        withCredentials: true,
      }).then(function(response) {
        return response.data;
      });
    },

    listPatientReviews: function(clinicIds) {
      if (_.isEmpty(clinicIds)) {
        return $q.reject();
      }
      var reviews = [];
      return clinicIds.reduce(function(promise, clinicId) {
        return promise.then(function() {
          return $http.get(ClinicConfig.HOSTNAME + '/clinic/' + clinicId + '/patient/review', {
            withCredentials: true,
          }).then(function(response) {
            reviews.push(response.data);
          });
        });
      }, $q.when()).then(function() {
        return _.chain(reviews).flatten()
          .compact()
          .value();
      });
    },
  };
});
